import { womanData } from '../lib/data';
import styles from './Woman.module.scss';


const Woman = () => {
    return ( 
        <section >
            <div className = {styles.container}> 
                {womanData.map(({id, photo}) => (
                    <div className = {styles.container__photo} key={id}> 
                    <img  className={styles.photo} src={photo} alt="женская фотосессия Ставрополь"/>
                    </div>
                ))}
            </div>
        </section>
     );
}
 
export default Woman;